var _rect, _rect2, _path, _circle, _rect3, _rect4, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 31,
    viewBox: "0 0 64 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28.5752,
    width: 5,
    height: 2,
    rx: 1,
    transform: "rotate(-31.0052 44 28.5752)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 3,
    width: 6,
    height: 20,
    rx: 3,
    transform: "rotate(-30 48 3)",
    fill: "#6D6D6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4403 28.3453C48.7656 28.9309 47.753 28.8951 47.1214 28.2634C46.4897 27.6318 46.4539 26.6192 47.0395 25.9445L57.1758 14.2657C58.2386 13.0411 60.1169 12.9748 61.2635 14.1213C62.41 15.2679 62.3437 17.1462 61.1191 18.209L49.4403 28.3453Z",
    fill: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0942,
    cy: 16.5322,
    r: 1.5,
    fill: "#6D6D6D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.92728,
    height: 1.98954,
    rx: 0.994771,
    transform: "matrix(-0.852505 -0.522719 -0.507544 0.861626 19 28.5752)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.91089,
    height: 19.9015,
    rx: 2.95545,
    transform: "matrix(-0.86163 -0.507537 -0.4925 0.870312 15.0794 3)",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6677 28.3453C14.329 28.9309 15.3215 28.8951 15.9406 28.2634C16.5597 27.6318 16.5948 26.6192 16.0209 25.9445L6.08579 14.2657C5.04406 13.0411 3.203 12.9748 2.0792 14.1213C0.955408 15.2679 1.02042 17.1462 2.22068 18.209L13.6677 28.3453Z",
    fill: "#303030"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.47022,
    ry: 1.5,
    transform: "matrix(-1 0 0 1 4.20537 16.5322)",
    fill: "#6D6D6D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArms);
export default __webpack_public_path__ + "static/media/arms.e2f0ff134803fb96415acc9af71761d3.svg";
export { ForwardRef as ReactComponent };